import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import userReducer from './user/user.reducer';
import tokenReducer from './token/token.reducer';
import roleReducer from './role/role.reducer';
import adminReducer from './admin/admin.reducer';
import errorMessageReducer from './error-message/error-message.reducer';
import responseReducer from './response/response.reducer';
import ordeDetailsReducer from './order-details/ordr-details.reducer';
import miscReducer from './misc-data/misc-data.reducer';
import authReducer from './auth/auth.reducer';
import billpayReducer from './billpayDetails/billpay.reducer';
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user',
        'role',
        'admin',
        'errorMessageReduce',
        'responseReduce',
        'ordeDetailsReduce',
        'miscReduce',
        'authReduce',
        'billpayReduce',
        
        ]
}

const rootReducer = combineReducers({
    user: userReducer,
    token: tokenReducer,
    role: roleReducer,
    admin:adminReducer,
    errorMessageReduce:errorMessageReducer,
    responseReduce:responseReducer,
    ordeDetailsReduce:ordeDetailsReducer,
    miscReduce:miscReducer,
    authReduce:authReducer,
    billpayReduce:billpayReducer,
})


export default persistReducer(persistConfig, rootReducer);